var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.102 22.3272C15.8896 22.3272 15.682 22.3902 15.5055 22.5081C15.3289 22.6261 15.1913 22.7938 15.11 22.99C15.0287 23.1862 15.0075 23.4021 15.0489 23.6104C15.0903 23.8186 15.1926 24.0099 15.3428 24.1601C15.4929 24.3103 15.6842 24.4125 15.8925 24.454C16.1008 24.4954 16.3167 24.4741 16.5129 24.3929C16.7091 24.3116 16.8767 24.174 16.9947 23.9974C17.1127 23.8208 17.1757 23.6132 17.1757 23.4009C17.1757 23.1161 17.0626 22.843 16.8612 22.6417C16.6598 22.4403 16.3867 22.3272 16.102 22.3272Z",
    fill: "#BC50CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.102 10.2481C16.5467 10.2481 16.9073 10.6086 16.9073 11.0534V19.1061C16.9073 19.5508 16.5467 19.9114 16.102 19.9114C15.6572 19.9114 15.2967 19.5508 15.2967 19.1061V11.0534C15.2967 10.6086 15.6572 10.2481 16.102 10.2481Z",
    fill: "#BC50CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40958 22.5457L12.7487 6.06156C14.1393 3.31281 18.0647 3.31281 19.4553 6.06156L27.7944 22.5457C29.0589 25.0453 27.2424 28 24.4411 28H7.76285C4.96154 28 3.14504 25.0453 4.40958 22.5457ZM14.1858 6.78858C14.9804 5.21787 17.2235 5.21787 18.0181 6.78858L26.3573 23.2727C27.0799 24.7011 26.0419 26.3895 24.4411 26.3895H7.76285C6.1621 26.3895 5.1241 24.7011 5.8467 23.2727L14.1858 6.78858Z",
    fill: "#BC50CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toast-error.6456314f02c9d3cb228e302ca7132bde.svg";
export { ForwardRef as ReactComponent };